module.exports = "/images/genius_logo.svg?edff301186381cfa2ce5af8bd33b2026";